export function createSpeechQueue(speak) {
  const waiting = [];
  let current = null;

  function finish(item, ok) {
    current = null;
    if (ok) item.call.onDone?.(item.call);
    else item.call.onFail?.(item.call);
    pump();
  }

  function start(item) {
    current = item;
    speak(item.call, {
      done: () => finish(item, true),
      fail: () => {
        if (!item.retried) {
          item.retried = true;
          start(item);
          return;
        }
        finish(item, false);
      },
    });
  }

  function pump() {
    if (current || waiting.length === 0) return;
    start(waiting.shift());
  }

  return {
    enqueue(call) {
      const chave = call.filaId || call.dedupKey;
      if (!chave) return;
      if ((current?.call.filaId || current?.call.dedupKey) === chave || waiting.some((item) => (item.call.filaId || item.call.dedupKey) === chave)) return;
      waiting.push({ call, retried: false });
      pump();
    },
    retainOnly(keys) {
      for (let indice = waiting.length - 1; indice >= 0; indice -= 1) {
        if (!keys.has(waiting[indice].call.dedupKey) && !keys.has(waiting[indice].call.filaId)) waiting.splice(indice, 1);
      }
    },
    snapshot() {
      return {
        current: current?.call.filaId || current?.call.dedupKey || null,
        waiting: waiting.map((item) => item.call.filaId || item.call.dedupKey),
      };
    },
  };
}
